// Notifikace nových měřených zpráv (událost mx:live ze socket.js).
// - V aplikaci: karta vpravo nahoře (na mobilu dole). Výchozí: desktop zapnuto, mobil vypnuto; mění se
//   v Account → Notifications nebo tlačítkem na kartě (nastavení notify.toast u účtu, moodix/web/prefs.py).
// - Upozornění prohlížeče: jen když je záložka na pozadí, uživatel je zapnul (notify.browser) a prohlížeč to povolil.
import { isNews } from './socket.js';
import { waitTranslation } from './translations.js';
import { gettext } from './i18n.js';

const MARKETS = { sp: 'S&P 500', oil: gettext('Crude oil') };
const MAX = 3;
const SHOW_MS = 10e3;
const MINUS = '−';
const signed = (v) => `${v > 0 ? '+' : v < 0 ? MINUS : ''}${Math.abs(v).toFixed(4)}`;
const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

function cfg() { return document.getElementById('mx-live')?.dataset || {}; }

export function toastsOn() {
  const t = cfg().toast;
  return t === 'on' || (t !== 'off' && !isMobile());
}

function dismiss(el) {
  el.classList.add('out');
  setTimeout(() => el.remove(), 250);
}

function showToast({ market, message: m }) {
  const box = document.getElementById('mx-toasts');
  if (!box) return;
  const value = Number(m.value) || 0;
  const url = `/${market}/news/${encodeURIComponent(m.id)}/`;
  const el = document.createElement('div');
  el.className = 'toast';
  el.setAttribute('role', 'status');
  el.innerHTML = `
    <a class="toast-b" href="${url}">
      <span class="toast-m"><i class="${market === 'oil' ? 'oil' : ''}"></i>${MARKETS[market] || market} · ${gettext('measured now')}</span>
      <span class="toast-t">${esc(m.text)}</span>
      <span class="toast-f"><b class="${value > 0 ? 'pos' : value < 0 ? 'neg' : ''}">${signed(value)}</b>${m.topic ? `<span class="topic">${esc(m.topic)}</span>` : ''}</span>
    </a>
    <div class="toast-a">
      <button type="button" class="toast-x" aria-label="${gettext('Close')}">×</button>
      <button type="button" class="toast-mute" title="${gettext('Turn off notifications')}" aria-label="${gettext('Turn off notifications')}">${gettext('Turn off')}</button>
    </div>`;
  el.querySelector('.toast-x').addEventListener('click', () => dismiss(el));
  el.querySelector('.toast-mute').addEventListener('click', () => {
    window.mxSavePref?.('notify.toast', 'off');
    const live = document.getElementById('mx-live');
    if (live) live.dataset.toast = 'off';
    box.querySelectorAll('.toast').forEach(dismiss);
    const note = document.createElement('div');
    note.className = 'toast note';
    note.innerHTML = gettext('Notifications are off. Turn them back on in <a href="/account/notifications/">Account → Notifications</a>.');
    box.prepend(note);
    setTimeout(() => dismiss(note), 6e3);
  });
  let timer = setTimeout(() => dismiss(el), SHOW_MS);
  el.addEventListener('mouseenter', () => clearTimeout(timer));
  el.addEventListener('mouseleave', () => { timer = setTimeout(() => dismiss(el), SHOW_MS / 2); });
  box.prepend(el);
  [...box.querySelectorAll('.toast:not(.note)')].slice(MAX).forEach(dismiss);
}

function showBrowser({ market, message: m }) {
  const value = Number(m.value) || 0;
  try {
    const n = new Notification(`${MARKETS[market] || market} ${signed(value)}`, {
      body: m.text, tag: `mx-${market}-${m.id}`, icon: '/static/assets/img/apple-touch-icon.png',
    });
    n.onclick = () => { window.focus(); window.location.href = `/${market}/news/${encodeURIComponent(m.id)}/`; n.close(); };
  } catch { /* prohlížeč notifikaci odmítl */ }
}

export function initNotify() {
  window.addEventListener('mx:live', (e) => {
    const { channel, message } = e.detail;
    if (!isNews(channel) || !message?.id || message.deleted || message.created === false) return;
    const hidden = document.visibilityState !== 'visible';
    const browser = hidden && cfg().browser === 'on' && 'Notification' in window && Notification.permission === 'granted';
    if (!browser && (hidden || !toastsOn())) return;
    // S doplňkem News in your language počkat na překlad titulku (nejdéle 3 s, pak anglicky)
    waitTranslation(`${e.detail.market}.m:${message.id}`).then((text) => {
      const detail = text ? { ...e.detail, message: { ...message, text } } : e.detail;
      if (browser) showBrowser(detail); else showToast(detail);
    });
  });
}

/** Account → Notifications: zapnutí upozornění prohlížeče (povolení si prohlížeč vyžádá po kliknutí). */
export async function enableBrowserNotifications() {
  if (!('Notification' in window)) return 'unsupported';
  const result = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
  if (result === 'granted') window.mxSavePref?.('notify.browser', 'on');
  return result;
}
